<template>
    <div style="position: absolute;top:0px;left:0px;width:414px;height:414px;transform-origin: 0px 0px;background-color: rgba(0,0,0,0);" :style="{ transform: 'scale('+transformScale+')' }">
        <div v-for="(stamp,i) in btn.grid" :key="i" :style="{ left: stamp.x+'px', top: stamp.y+'px' }" style="width:138px;position: absolute;">
            <img :src="btn.qty <= i ? btn.loyaltyPlain : btn.loyaltyStamp" style="width: 100%"/>
        </div>
    </div>
</template>

<script>

export default {
    props: ['btn'],
    data () {
        return {
            transformScale: 1,
        }
    },
    watch: {
        btn: {
            deep: true,
            handler ( btn ) {
                this.updateScale(btn);
            } 
        }
    },
    mounted () {
        this.updateScale(this.btn);
    },
    methods: {
        updateScale ( btn ) {
            this.transformScale = btn.width / 414;
        }
    }
}

</script>

<style>

</style>